<template>
    <div>
        <div v-if="isLoading" class="timeline-email">
            <v-inline-loader/>
        </div>
        <div v-else>
            <email-preview
                :subject="model.subject"
                :html="model.html"
                :text="model.text"/>
            <div class="divider"></div>
            <message-attachments
                :entity-id="entityId"
                :model="model"/>
        </div>
    </div>
</template>

<script>
    import {vIcon, vIconButton} from '@/components/form';
    import EmailMessageModel from '@/common/models/email-message-model';
    import vInlineLoader from '@/components/v-inline-loader';
    import EmailPreview from './email-preview';
    import MessageAttachments from './message-attachments';
    import AsyncMessageDetailsMixin from '../async-message-details-mixin';

    export default {
        name: 'message-action',
        mixins: [
            new AsyncMessageDetailsMixin({
                Model: EmailMessageModel,
            }).getMixin(),
        ],
        components: {
            vInlineLoader,
            vIconButton,
            vIcon,
            EmailPreview,
            MessageAttachments,
        },
        props: {
            action: {
                type: String,
                required: true,
            },
        },
        methods: {
            async getDelegate(callback) {
                return this.$api(({emailMessages}) => callback(emailMessages));
            },
        },
        watch: {
            action: {
                immediate: true,
                handler() {
                    this.fetchData();
                },
            },
        },
    };
</script>
